
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedPortfolioProject_UserPortfolioProject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserPortfolioProject_Project"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifacts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedPortfolioProject_UserPortfolioProject_Artifacts"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPublished"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkToWork"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"summary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approach"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedPortfolioProject_UserPortfolioProject_CmlContent"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"solution"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedPortfolioProject_UserPortfolioProject_CmlContent"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedPortfolioProject_ProjectDetails"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isAutoPublished"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedPortfolioProject_UserPortfolioProject_CmlContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CmlContent"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cmlValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dtdId"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedPortfolioProject_UserPortfolioProject_Artifacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioProject_Artifact"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignmentTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":789}};
    doc.loc.source = {"body":"#import \"./SharedPortfolioProject_ProjectDetails.graphql\"\n\nfragment SharedPortfolioProject_UserPortfolioProject on UserPortfolioProject_Project {\n  artifacts {\n    ...SharedPortfolioProject_UserPortfolioProject_Artifacts\n  }\n  lastUpdated\n  isPublished\n  completed\n  id\n  linkToWork\n  summary\n  approach {\n    ...SharedPortfolioProject_UserPortfolioProject_CmlContent\n  }\n  solution {\n    ...SharedPortfolioProject_UserPortfolioProject_CmlContent\n  }\n  project {\n    ...SharedPortfolioProject_ProjectDetails\n  }\n  isAutoPublished\n}\n\nfragment SharedPortfolioProject_UserPortfolioProject_CmlContent on CmlContent {\n  cmlValue\n  dtdId\n}\n\nfragment SharedPortfolioProject_UserPortfolioProject_Artifacts on PortfolioProject_Artifact {\n  assignmentLink\n  link\n  itemId\n  assignmentTitle\n  type\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./SharedPortfolioProject_ProjectDetails.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SharedPortfolioProject_UserPortfolioProject"] = oneQuery(doc, "SharedPortfolioProject_UserPortfolioProject");
        
        module.exports["SharedPortfolioProject_UserPortfolioProject_CmlContent"] = oneQuery(doc, "SharedPortfolioProject_UserPortfolioProject_CmlContent");
        
        module.exports["SharedPortfolioProject_UserPortfolioProject_Artifacts"] = oneQuery(doc, "SharedPortfolioProject_UserPortfolioProject_Artifacts");
        
